// extracted by mini-css-extract-plugin
export default {"areaChart":"areaChart_areaChart__7Mig-"};